/* src/app/layout/components/navbar/horizontal/style-1/style-1.component.scss */
navbar.horizontal-style-1 {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  height: 56px;
  max-height: 56px;
  min-height: 56px;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9sYXlvdXQvY29tcG9uZW50cy9uYXZiYXIvaG9yaXpvbnRhbC9zdHlsZS0xL3N0eWxlLTEuY29tcG9uZW50LnNjc3MiXSwKICAic291cmNlc0NvbnRlbnQiOiBbIm5hdmJhci1ob3Jpem9udGFsLXN0eWxlLTEge1xufVxuXG5uYXZiYXIge1xuICAgICYuaG9yaXpvbnRhbC1zdHlsZS0xIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgZmxleDogMSAxIGF1dG87XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBoZWlnaHQ6IDU2cHg7XG4gICAgICAgIG1heC1oZWlnaHQ6IDU2cHg7XG4gICAgICAgIG1pbi1oZWlnaHQ6IDU2cHg7XG4gICAgfVxufVxuIl0sCiAgIm1hcHBpbmdzIjogIjtBQUlJLE1BQUEsQ0FBQTtBQUNJLFdBQUE7QUFDQSxrQkFBQTtBQUNBLFFBQUEsRUFBQSxFQUFBO0FBQ0EsU0FBQTtBQUNBLFVBQUE7QUFDQSxjQUFBO0FBQ0EsY0FBQTs7IiwKICAibmFtZXMiOiBbXQp9Cg== */
